<template>
  <div class="min-h-screen w-full">
    <slot />
  </div>
</template>
